import {getTreeListByDictType} from '@/api/dict';
import {findJobPagesByEnterpriseId} from "@/api/job";

const state = {
    mode: 'position'
}

// getters
const getters = {};

const actions = {
    /** 根据key获取词典*/
    getTreeListByDictType({state, commit}, key) {
        return new Promise((resolve, reject) => {
            getTreeListByDictType(key).then(res => {
                resolve(res.data);
            });
        })
    },
    /** 获取职位列表*/
    getJobPositionList({state, commit}, payload) {
        return new Promise((resolve, reject) => {
            let params = {};
            Object.assign(params, payload);
            if (params.wageList) {
                params.wageList = JSON.stringify(params.wageList)
                    .replace("\"", "%22")
                    .replace("{", "%7b")
                    .replace("}", "%7d")
                    .replace("[", "%5B")
                    .replace("]", "%5D");
            }
            findJobPagesByEnterpriseId(payload.enterpriseId, params).then((res) => {
                resolve(res);
            });
        });
    }
};

// mutations
const mutations = {};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
